import { Button, Dropdown, Space } from "antd";
import {
  DownOutlined,
  FileExcelOutlined,
  FilePdfOutlined,
} from "@ant-design/icons";
import { CSVLink } from "react-csv";
import StatusSetter from "../../util/StatusSetter";

import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import "../../util/IRANSansWeb-normal";
import LastPlacementTestSetter from "../../util/LastPlacementTestSetter";
import dayjs from "dayjs";

const TableExportDropdown = ({ name, data, columns, disabled }) => {
  const nowDate = dayjs(new Date(), { jalali: true });
  const fileName = `${name} - ${nowDate.get("day")}/${nowDate.get(
    "month"
  )}/${nowDate.get("year")}`;
  let CSVDataSource = [];
  let PDFDataSource = [];
  let RenderColumns = [];
  if (columns) {
    columns.forEach((column) => {
      if (!column.title.includes("عملیات")) {
        RenderColumns.push(column);
      }
    });
    if (Array.isArray(data)) {
      CSVDataSource = data.map((row) => {
        const newRow = {};
        Object.keys(row).forEach((key) => {
          columns.forEach((column) => {
            const rowData = row[key];

            if (key === column.dataIndex) {
              if (key === "status") {
                newRow[column.title] = StatusSetter(rowData);
              } else {
                newRow[column.title] = rowData;
              }
            }
            if (key === "placement_tests") {
              if (LastPlacementTestSetter(row)) {
                newRow["تاریخ تعیین سطح"] =
                  LastPlacementTestSetter(row).jactive_due_date;
              }
            }
          });
        });

        return newRow;
      });
      PDFDataSource = data.map((row) => {
        const newRow = {};
        Object.keys(row).forEach((key) => {
          const rowData = row[key];
          if (key === "status") {
            newRow[key] = StatusSetter(rowData);
          } else if (key === "placement_tests") {
            if (LastPlacementTestSetter(row)) {
              newRow["test_date"] =
                LastPlacementTestSetter(row).jactive_due_date;
            }
          } else {
            newRow[key] = rowData;
          }
        });

        return newRow;
      });
    }
  }
  const handlePrint = () => {
    var doc = new jsPDF("l", "mm", [297, 210]);
    doc.setLanguage("fa-IR");

    autoTable(doc, {
      body: PDFDataSource.reverse(),
      styles: { font: "IRANSansWeb", halign: "right" },
      columns: RenderColumns.reverse(),
    });
    doc.save(fileName + ".pdf");
  };
  const items = [
    {
      label: (
        <CSVLink filename={`${fileName} .csv`} data={CSVDataSource}>
          <Space align="center">
            <FileExcelOutlined /> اکسل (Excel){" "}
          </Space>
        </CSVLink>
      ),
      key: "0",
    },
    {
      label: (
        <Space onClick={handlePrint} align="center">
          <FilePdfOutlined /> پی دی اف (PDF)
        </Space>
      ),
      key: "1",
    },
  ];
  return (
    <Dropdown
      disabled={disabled}
      menu={{
        items,
      }}
      trigger={["click"]}
    >
      <Button>
        <Space>
          <DownOutlined />
          خروجی
        </Space>
      </Button>
    </Dropdown>
  );
};
export default TableExportDropdown;
